import { Col, Row } from 'react-bootstrap';
import { getBoolean, getString } from './renderers';
import { IDonorRegistration } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const SocialHistory = (props: IProps) => {
    return (
        <div id='social-history' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Social History</span>
                </div>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Has Used Alcohol?</Col>
                    <Col xs={6} sm={4}>
                        {getBoolean(props.data.hasUsedAlcohol)}
                    </Col>
                </Row>

                {(props.data.hasUsedAlcohol) && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - currently uses alcohol:</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.usesAlcohol)}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>&nbsp; - how much:</Col>
                            <Col xs={6} sm={4}>
                                {props.data.alcoholDrinks}/{props.data.alcoholFrequency}
                            </Col>
                        </Row>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>Has Abused Alcohol?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.hasAbusedAlcohol)}
                            </Col>
                        </Row>
                    </>
                )}

                {props.data.drugUse != null ? (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>History of recreational drug use?</Col>
                        <Col xs={6} sm={4}>
                            {!(props.data.drugUse) ? '[not answered]' :
                                (props.data.drugUse == 'None' ? <span className='label label-success'>None</span> :
                                    <span className='label label-important'>{props.data.drugUse}</span>)}
                        </Col>
                    </Row>
                ) : (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8} className='item-label'>Has Used Drugs?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.hasUsedDrugs)}
                            </Col>
                        </Row>

                        {(props.data.hasUsedDrugs) && (
                            <>
                                {props.data.drugUseHistory == null ? (
                                    <>
                                        <Row className='row-underlined row-value-center'>
                                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Treated for Substance Abuse?</Col>
                                            <Col xs={6} sm={4}>
                                                {getBoolean(props.data.hasBeenTreatedForDrugAbuse)}
                                            </Col>
                                        </Row>
                                        <Row className='row-underlined row-value-center'>
                                            <Col xs={6} sm={8} className='item-label'>&nbsp; - Drugs Used</Col>
                                            <Col xs={6} sm={4}>
                                                <ul>
                                                    {/*{foreach(props.data.drugUse as $int) {*/}
                                                    {/*  $drug = new DrugUse($int); ?>*/}
                                                    {/*  <li>{$drug}</li>*/}
                                                    {/*}}*/}
                                                </ul>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <>
                                        <Row className='row-underlined row-value-center'>
                                            <Col xs={9} xsOffset={1}>
                                                <TableWrapper condensed striped>
                                                    <thead>
                                                        <tr>
                                                            <th>Drugs Used</th>
                                                            <th>Last Used</th>
                                                            <th>Got Treatment?</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {props.data.drugUseHistory.map((item, index) =>
                                                            <tr key={'drug-' + index}>
                                                                <td>{item.recreationalDrug}</td>
                                                                <td>{item.yearsAgo}</td>
                                                                <td>{item.hasReceivedTreatment}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </TableWrapper>
                                            </Col>
                                            <div>&nbsp;</div>
                                        </Row>
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8}>Has had legal issues w/ law enforcement?</Col>
                    <Col xs={6} sm={4}>
                        {getBoolean(props.data.hasHadLegalIssues)}
                    </Col>
                </Row>

                {(props.data.hasHadLegalIssues) && (
                    <>
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8}>Has been sentenced to prison?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.hasBeenSentencedToPrison)}
                            </Col>
                        </Row>
                        {(props.data.hasBeenSentencedToPrison) && (
                            <Row className='row-underlined row-value-center'>
                                <Col xs={6} sm={8}>When and where in prison?</Col>
                                <Col xs={6} sm={4}>
                                    {getString(props.data.prisonWhenAndWhere)}
                                </Col>
                            </Row>
                        )}
                    </>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8}>Traveled over 100 miles from home in the last year?</Col>
                    <Col xs={6} sm={4}>
                        {getBoolean(props.data.hasTraveledLastYear)}
                    </Col>
                </Row>

                {(props.data.hasTraveledLastYear) && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>&nbsp; - Traveled Where?</Col>
                        <Col xs={6} sm={4}>
                            {getString(props.data.travelLocations)}
                        </Col>
                    </Row>
                )}

                {(props.data.hasHadHighRiskSex) && (<>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has had sex with risk of HIV, HBV, HCV?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasHadHighRiskSex)}
                        </Col>
                    </Row>


                    {(props.data.hasHadHighRiskSex) && props.data.gender == 'Female' ? (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8}>Has had sex with male who has had male-male sex?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.hasHadSexWithMmRelationsMale)}
                            </Col>
                        </Row>
                    ) : (
                        <Row className='row-underlined row-value-center'>
                            <Col xs={6} sm={8}>Has had male-male sex?</Col>
                            <Col xs={6} sm={4}>
                                {getBoolean(props.data.hasHadMmSex)}
                            </Col>
                        </Row>
                    )}


                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has had sex with prostitute?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasHadSexWithProstitute)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has prostituted?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasProstituted)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has had sex with someone who uses needles for non-prescription drug use?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasHadSexWithNeedleDrugUser)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has used needles for non-prescription drug use?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasUsedNeedleDrugs)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has been in jail over 72 hours?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasBeenInJailOver72)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has contracted an STD?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasHadStd)}
                        </Col>
                    </Row>
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8}>Has been on hemodialysis?</Col>
                        <Col xs={6} sm={4}>
                            {getBoolean(props.data.hasBeenOnHemodialysis)}
                        </Col>
                    </Row>
                </>)}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8}>Has had suicidal thoughts or attempts in the last five years?</Col>
                    <Col xs={6} sm={4}>
                        {getBoolean(props.data.hasHadSuicidalThoughtsAttempts)}
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default SocialHistory;